import { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./context/PrivateRoute";
import AdminPrivateRoute from "./context/AdminPrivateRoute";
import {
  AdminLayout,
  AuthLogin,
  ClinicLayout,
  LandingDashboard,
  LandingLayout,
  adminRoutes,
  clinicRoutes,
  landingRoutes,
} from "./routes/appRoutes";

const AppLoader = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "100vh" }}
  >
    <div
      className="spinner-border text-primary"
      role="status"
      aria-label="Loading"
    />
  </div>
);

const renderRoutes = (routeList, secure = false) =>
  routeList.map(({ index, path, element, allowedRoles, adminPermission }) => {
    let routeElement = element;

    if (adminPermission) {
      routeElement = (
        <AdminPrivateRoute requiredPermission={adminPermission}>
          {routeElement}
        </AdminPrivateRoute>
      );
    }

    if (secure && allowedRoles) {
      routeElement = (
        <PrivateRoute allowedRoles={allowedRoles}>{routeElement}</PrivateRoute>
      );
    }

    if (index) {
      return <Route key="index" index element={routeElement} />;
    }

    return <Route key={path} path={path} element={routeElement} />;
  });

function App() {
  return (
    <div className="main-container">
      <Router>
        <Suspense fallback={<AppLoader />}>
          <Routes>
            <Route path="/" element={<LandingLayout />}>
              <Route index element={<LandingDashboard />} />
            </Route>
            {renderRoutes(landingRoutes)}

            <Route path="/admin/login" element={<AuthLogin role="admin" />} />
            <Route
              path="/admin"
              element={
                <AdminPrivateRoute>
                  <AdminLayout />
                </AdminPrivateRoute>
              }
            >
              {renderRoutes(adminRoutes)}
            </Route>

            <Route
              path="/clinic"
              element={
                <PrivateRoute>
                  <ClinicLayout />
                </PrivateRoute>
              }
            >
              {renderRoutes(clinicRoutes, true)}
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
